<script>
	import router from "page";
	import { onMount } from "svelte";
	import routes from "./routes.js";
  
	let page;
	let params;
	let user = true;

	onMount(async () => {
		// The following code is based off a toggle menu by @Bradcomp
		// source: https://gist.github.com/Bradcomp/a9ef2ef322a8e8017443b626208999c1
		(function() {
			var burger = document.querySelector('.burger');
			var menu = document.querySelector('#'+burger.dataset.target);
			burger.addEventListener('click', function() {
				burger.classList.toggle('is-active');
				menu.classList.toggle('is-active');
			});
		})();
		document.addEventListener("DOMContentLoaded", function() {
		//The first argument are the elements to which the plugin shall be initialized
		//The second argument has to be at least a empty object or a object with your desired options
			OverlayScrollbars(document.querySelectorAll("body"), { });
		});
	});
  
	// Iterate through the routes
	routes.forEach(route => {
	  router(
		route.path,
		(ctx, next) => {
		  params = ctx.params;
		  next();
		},
  
		() => {
		  if (route.auth && !user) {
			router.redirect("/login");
		  } else {
			page = route.component;
		  }
		}
	  );
	});
  
	// Start the router
	router.start();
  </script>
  
  <!-- START NAV -->
<nav class="navbar">
	<div class="container">
		<div class="navbar-brand">
			<a class="navbar-item is-large" href="/" onclick="javascript:location.reload();">
				<h4 class="title is-4"><span class="icon has-text-info"><img src="/images/bulma.png" alt="Logo"></span> <span> Revolution Trails</span></h4>
			</a>
			<span class="navbar-burger burger" data-target="navbarMenu">
					<span></span>
			<span></span>
			<span></span>
			</span>
		</div>
		<div id="navbarMenu" class="navbar-menu">
			<div class="navbar-end">
				<a class="navbar-item" href="/">
						Home
					</a>
				<a class="navbar-item" href="/venues">
						Venues
					</a>
				<a class="navbar-item" href="/challenge">
						Challenges
					</a>	
				
				<!-- <div class="navbar-item has-dropdown is-hoverable">
					<a class="navbar-link">
							Account
						</a>
					<div class="navbar-dropdown">
						<a class="navbar-item">
								Dashboard
							</a>
						<a class="navbar-item">
								Profile
							</a>
						<a class="navbar-item">
								Settings
							</a>
						<hr class="navbar-divider">
						<div class="navbar-item">
							Logout
						</div>
					</div>
				</div> -->
			</div>
		</div>
	</div>
</nav>
<!-- END NAV -->
<div class="container">
<svelte:component this={page} params={params} />		  
</div>
  